var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5B3552",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M.833 9.5S4.167 2.833 10 2.833 19.167 9.5 19.167 9.5 15.833 16.167 10 16.167.833 9.5.833 9.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5B3552",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
  })));
};
export { SvgEye as ReactComponent };
export default __webpack_public_path__ + "images/eye.svg";